import { useEffect, useState } from "react";
import LogoClara from "./LogoClara";
import { cn } from "@/lib/utils";

interface TelaCarregandoProps {
  /** Texto curto para leitor de tela. */
  rotulo?: string;
}

/**
 * Abertura do app e do painel: a logo se desenha no meio da tela clara e fica cintilando enquanto a sessão e os dados
 * carregam. Se demorar, aparece um aviso discreto.
 */
const TelaCarregando = ({ rotulo = "Carregando" }: TelaCarregandoProps) => {
  const [demorou, setDemorou] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setDemorou(true), 7000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      role="status"
      aria-label={rotulo}
      className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-background px-6"
    >
      <LogoClara animar continuo className="h-36 w-auto" />
      <p className="logo-clara-palavra text-[13px] font-semibold uppercase tracking-[0.34em] text-muted-foreground">
        Clara Camille
      </p>
      <p
        className={cn(
          "h-5 text-[13px] text-muted-foreground transition-opacity duration-500",
          demorou ? "opacity-100" : "opacity-0",
        )}
      >
        Conectando… confira a internet se demorar.
      </p>
    </div>
  );
};

export default TelaCarregando;
